import React from 'react';

import type { BenefitCardProps } from './BenefitCard.types';

import styles from './BenefitCard.module.scss';

const BenefitCard: React.FC<BenefitCardProps> = ({ content, heading, icon }) => (
	<article className={styles.card}>
		<div className={styles.iconText}>
			<div className={styles.icon}>{icon}</div>
			<div className={styles.heading}>{heading}</div>
		</div>
		{content}
	</article>
);

export default BenefitCard;
